import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, type PropType } from 'vue';

import type { OrderWithTradesModel } from '@exchange/libs/order/shared-model/src/lib/order-model';
import { toastManagerInstance, OrderCancelFailedToast } from '@exchange/libs/toasts/src';

type CloseButtonVariant = 'desktop' | 'mobile';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderCloseButton',
  props: {
  cancelOrder: { type: Function as PropType<(id: string) => Promise<void>>, required: true },
  marketInMaintenance: { type: Boolean, required: true },
  order: { type: Object as PropType<OrderWithTradesModel>, required: true },
  variant: { type: String as PropType<CloseButtonVariant>, default: 'desktop' },
},
  setup(__props, { expose: __expose }) {

const props = __props;

const showOrderCloseButton = computed(() => props.order.isCancelable && !props.marketInMaintenance);

const closeOrder = () =>
  props.cancelOrder(props.order.id).catch((error) =>
    toastManagerInstance.addToast({
      content: OrderCancelFailedToast,
      props: {
        errorCode: error.data ? error.data.error : undefined,
      },
    }),
  );

__expose({
  showOrderCloseButton,
  closeOrder,
});

return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!

  return (showOrderCloseButton.value)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: _normalizeClass(["order-close-button", [`order-close-button--${__props.variant}`]]),
        name: "close-order-button",
        onClick: closeOrder
      }, [
        _createVNode(_component_ot_icon, { name: "close-square" })
      ], 2))
    : _createCommentVNode("", true)
}
}

})